import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Search, FileText, Handshake } from 'lucide-react';
export const HowItWorksSection = () => {
  const steps = [{
    num: '1',
    title: 'Audita',
    desc: 'Identifica errores y datos obsoletos en tus reportes oficiales gratuitos.',
    icon: <Search className="w-8 h-8 text-gold-500" data-id="element-57" />
  }, {
    num: '2',
    title: 'Disputa',
    desc: 'Envía las cartas de desafío legal incluidas usando nuestro lenguaje técnico de abogado.',
    icon: <FileText className="w-8 h-8 text-gold-500" data-id="element-58" />
  }, {
    num: '3',
    title: 'Negocia',
    desc: 'Cierra tus deudas en colección por mucho menos de lo que debes y exige el borrado inmediato.',
    icon: <Handshake className="w-8 h-8 text-gold-500" data-id="element-59" />
  }];
  return <SectionWrapper bg="bg-navy-900" data-id="element-60">
      <h2 className="font-serif text-3xl md:text-5xl font-bold text-center mb-16 text-white" data-id="element-61">
        Cómo funciona en <span className="text-gold-500" data-id="element-62">3 simples pasos</span>
      </h2>

      <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-63">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-navy-800 z-0" data-id="element-64"></div>

        {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center group" data-id="element-65">
            <div className="w-24 h-24 bg-navy-800 rounded-full flex items-center justify-center mb-6 border-4 border-navy-900 shadow-xl group-hover:border-gold-500/50 transition-colors duration-300 relative" data-id="element-66">
              {step.icon}
              <div className="absolute -top-2 -right-2 w-8 h-8 bg-gold-500 rounded-full flex items-center justify-center text-navy-900 font-bold text-lg shadow-lg" data-id="element-67">
                {step.num}
              </div>
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-68">{step.title}</h3>
            <p className="text-gray-400 text-lg px-4" data-id="element-69">{step.desc}</p>
          </div>)}
      </div>
    </SectionWrapper>;
};